module.exports = __webpack_public_path__ + "img/vaidesn_sm.c6b298ad.jpg";